import React, { Component } from 'react';
import { Modal, Button, Spin, Tooltip, notification, Switch, Pagination, Empty, Input, Table, Avatar, Form, Typography } from 'antd';
import { fetchData } from '../../../lib/apis';
import { DesktopOutlined, PlusOutlined, DeleteOutlined, ReloadOutlined, EditOutlined, CodeOutlined } from '@ant-design/icons';
import moment from 'moment';

const { Paragraph } = Typography;

export default class WebChatChannel extends Component {
    constructor(props) {
        super(props);
        this.formRef = React.createRef();
        this.state = {
            listData: [],
            total: 0,
            loading: false,
            visibleModal: false,
            visibleScriptModal: false,
            editingChannel: null,
            selectedToken: null,
            submitting: false,
            webchatAppUrl: 'http://localhost:5173' // Default fallback
        };
        this.limit = 20;
        this.page = 1;
    }

    componentDidMount() {
        this.getListData();
        this.getAppUrl();
    }

    getAppUrl = async () => {
        try {
            let res = await fetchData({
                url: `api/v1/webchat/app-url`
            });
            if (res.code === 200) {
                this.setState({ webchatAppUrl: res.url });
            }
        } catch (err) {
            console.error('Error fetching WebChat App URL:', err);
        }
    }

    getListData = async () => {
        try {
            this.setState({ loading: true });
            let res = await fetchData({
                url: `api/v1/webchat/channel`
            });

            this.setState({
                listData: res.data || [],
                total: res.data?.length || 0,
                loading: false
            });
        } catch (err) {
            this.setState({ loading: false });
            console.error('Error fetching WebChat channels:', err);
        }
    }

    deleteChannel = async (id) => {
        Modal.confirm({
            title: 'Xác nhận xóa',
            content: 'Bạn có chắc muốn xóa kênh Web Chat này?',
            okText: 'Xóa',
            okType: 'danger',
            cancelText: 'Hủy',
            onOk: async () => {
                try {
                    await fetchData({
                        url: `api/v1/webchat/channel`,
                        method: 'delete',
                        data: { ids: [id] }
                    });
                    notification.success({
                        message: 'Thành công',
                        description: 'Đã xóa kênh'
                    });
                    this.getListData();
                } catch (err) {
                    notification.error({
                        message: 'Lỗi',
                        description: err.message || 'Không thể xóa kênh'
                    });
                }
            }
        });
    }

    enableChannel = async (id, enable) => {
        try {
            await fetchData({
                url: `api/v1/webchat/channel/toggle`,
                method: 'post',
                data: { enable: enable ? 1 : 0, ids: [id] }
            });
            notification.success({
                message: 'Thành công',
                description: enable ? 'Đã bật kích hoạt' : 'Đã tắt kích hoạt'
            });
        } catch (err) {
            notification.error({
                message: 'Lỗi',
                description: err.message || 'Thao tác thất bại'
            });
        }
    }

    openModal = (channel = null) => {
        this.setState({
            visibleModal: true,
            editingChannel: channel
        }, () => {
            if (this.formRef.current) {
                if (channel) {
                    this.formRef.current.setFieldsValue({
                        name: channel.name,
                        avatar: channel.avatar,
                        welcome_message: channel.welcome_message,
                        theme_color: channel.theme_color
                    });
                } else {
                    this.formRef.current.resetFields();
                }
            }
        });
    }

    handleSubmit = async (values) => {
        this.setState({ submitting: true });
        try {
            const { editingChannel } = this.state;
            const companyId = this.props.UserLogin?.company_id || this.props.companySelected?.company_id;
            
            let url = `api/v1/webchat/channel`;
            let method = 'post';
            
            if (editingChannel) {
                url = `api/v1/webchat/channel/${editingChannel._id}`;
                method = 'put';
            }

            await fetchData({
                url,
                method,
                data: { ...values, companyId }
            });

            notification.success({
                message: 'Thành công',
                description: editingChannel ? 'Đã cập nhật kênh' : 'Đã tạo kênh Web Chat mới'
            });
            
            this.setState({ visibleModal: false, submitting: false });
            this.getListData();
        } catch (err) {
            this.setState({ submitting: false });
            notification.error({
                message: 'Lỗi',
                description: err.message || 'Có lỗi xảy ra'
            });
        }
    }

    showScript = (token) => {
        this.setState({
            visibleScriptModal: true,
            selectedToken: token
        });
    }

    render() {
        const { listData, loading, visibleModal, editingChannel, submitting, visibleScriptModal, selectedToken, webchatAppUrl } = this.state;
        
        // Dùng webchatAppUrl cho script src

        const scriptSnippet = `<!-- Nhúng Script Web Chat CRM -->
<script 
    src="${webchatAppUrl}/webchat-widget.umd.cjs" 
    data-token="${selectedToken}"
></script>`;

        const directLink = `${webchatAppUrl}/${selectedToken}`;

        return (
            <div className="list-connect content-m">
                {/* Modal Config */}
                <Modal
                    title={editingChannel ? "Cập nhật kênh Web Chat" : "Tạo kênh Web Chat mới"}
                    visible={visibleModal}
                    onCancel={() => this.setState({ visibleModal: false })}
                    footer={null}
                    destroyOnClose={true}
                >
                     <Form
                        ref={this.formRef}
                        layout="vertical"
                        onFinish={this.handleSubmit}
                        initialValues={{ theme_color: '#0084ff', welcome_message: 'Xin chào! Chúng tôi có thể giúp gì cho bạn?' }}
                    >
                        <Form.Item
                            name="name"
                            label="Tên Website/Kênh"
                            rules={[{ required: true, message: 'Vui lòng nhập tên kênh' }]}
                        >
                            <Input placeholder="Ví dụ: Cửa hàng ABC" />
                        </Form.Item>
                        <Form.Item
                            name="avatar"
                            label="Avatar URL (Bot)"
                        >
                            <Input placeholder="https://..." />
                        </Form.Item>
                        <Form.Item
                            name="welcome_message"
                            label="Lời chào tự động"
                        >
                            <Input.TextArea rows={2} placeholder="Nhập lời chào..." />
                        </Form.Item>
                        <Form.Item
                            name="theme_color"
                            label="Màu chủ đạo (Hex Code)"
                        >
                            <Input type="color" style={{ width: 100, padding: 0 }} />
                        </Form.Item>
                        <div className="d-flex justify-content-end mt-4">
                            <Button onClick={() => this.setState({ visibleModal: false })} style={{ marginRight: 8 }}>
                                Hủy
                            </Button>
                            <Button type="primary" htmlType="submit" loading={submitting}>
                                Lưu lại
                            </Button>
                        </div>
                    </Form>
                </Modal>

                {/* Script Modal */}
                <Modal
                    title="Tích hợp Web Chat"
                    visible={visibleScriptModal}
                    onCancel={() => this.setState({ visibleScriptModal: false })}
                    width={600}
                    footer={[
                        <Button key="close" onClick={() => this.setState({ visibleScriptModal: false })}>Đóng</Button>
                    ]}
                >
                    <div style={{ marginBottom: 20 }}>
                        <Typography.Title level={5}>1. Link Chat trực tiếp (Generative Link)</Typography.Title>
                        <p>Sử dụng link này để gửi cho khách hàng chat ngay lập tức hoặc gắn vào nút trên Facebook/Zalo.</p>
                        <div style={{ background: '#f5f5f5', padding: 15, borderRadius: 5, marginBottom: 10 }}>
                            <Paragraph copyable style={{ margin: 0 }}>
                                {directLink}
                            </Paragraph>
                        </div>
                        <Button type="link" href={directLink} target="_blank" icon={<DesktopOutlined />} style={{ padding: 0 }}>
                            Mở thử trang chat
                        </Button>
                    </div>

                    <hr style={{ border: '0.5px solid #eee', margin: '20px 0' }} />

                    <div>
                        <Typography.Title level={5}>2. Mã nhúng Website (Widget Script)</Typography.Title>
                        <p>Hãy copy đoạn mã dưới đây và dán vào thẻ <code>&lt;body&gt;</code> trên website của bạn để hiển thị khung chat góc màn hình.</p>
                        <div style={{ background: '#f5f5f5', padding: 15, borderRadius: 5 }}>
                            <Paragraph copyable={{ text: scriptSnippet }} style={{ margin: 0 }}>
                                <pre style={{ margin: 0, whiteSpace: 'pre-wrap', wordBreak: 'break-all' }}>
                                    {scriptSnippet}
                                </pre>
                            </Paragraph>
                        </div>
                    </div>
                </Modal>

                <div className="list-c">
                    <div style={{ marginBottom: "15px" }} className="table-header">
                        <h3>
                            <DesktopOutlined style={{ marginRight: 8, color: '#0068FF' }} />
                            Quản lý kênh Web Chat (Tích hợp Website)
                        </h3>
                        <div className="d-flex overflow-auto" style={{ marginBottom: "15px" }}>
                            <Button 
                                type="primary" 
                                icon={<PlusOutlined />}
                                style={{ background: '#0068FF', borderColor: '#0068FF', marginRight: 8 }}
                                onClick={() => this.openModal()}
                            >
                                Thêm Kênh mới
                            </Button>
                            <Tooltip title="Làm mới">
                                <Button icon={<ReloadOutlined />} onClick={this.getListData} />
                            </Tooltip>
                        </div>
                    </div>

                    <div className="table-responsive">
                        <Spin spinning={loading}>
                            {listData.length > 0 ? (
                                <table className="table table-striped table-vcenter">
                                    <thead>
                                        <tr>
                                            <th>STT</th>
                                            <th>Ảnh</th>
                                            <th>Tên Website</th>
                                            <th>Màu chủ đạo</th>
                                            <th>Trạng thái</th>
                                            <th>Kích hoạt</th>
                                            <th>Thời gian tạo</th>
                                            <th className="text-right">Hành động</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {listData.map((item, i) => {
                                            const stt = this.limit * (this.page - 1) + (i + 1);
                                            return (
                                                <tr key={item._id}>
                                                    <td>{stt}</td>
                                                    <td>
                                                        <div style={{ width: "35px", height: "35px", position: "relative" }}>
                                                            {item.avatar ? (
                                                                <img className="avatar" src={item.avatar} alt="" />
                                                            ) : (
                                                                <div style={{
                                                                    width: 35,
                                                                    height: 35,
                                                                    borderRadius: '50%',
                                                                    background: item.theme_color || '#0068FF',
                                                                    display: 'flex',
                                                                    alignItems: 'center',
                                                                    justifyContent: 'center',
                                                                    color: '#fff',
                                                                    fontSize: 16
                                                                }}>
                                                                    <DesktopOutlined />
                                                                </div>
                                                            )}
                                                            <span 
                                                                style={{ position: "absolute", bottom: "0px", right: "0px" }} 
                                                                className={`badge-status badge badge-${item.status == 1 ? 'success' : 'danger'}`}
                                                            />
                                                        </div>
                                                    </td>
                                                    <td>{item.name}</td>
                                                    <td>
                                                        <span style={{ display: 'inline-block', width: 20, height: 20, background: item.theme_color || '#0068FF', borderRadius: 4, verticalAlign: 'middle', marginRight: 8 }}></span>
                                                        {item.theme_color || '#0084ff'}
                                                    </td>
                                                    <td>
                                                        <span className={`badge badge-${item.status == 1 ? 'success' : 'warning'}`}>
                                                            {item.status == 1 ? 'Hoạt động' : 'Tạm dừng'}
                                                        </span>
                                                    </td>
                                                    <td>
                                                        <Switch 
                                                            defaultChecked={item.status == 1} 
                                                            onChange={(e) => this.enableChannel(item._id, e)}
                                                        />
                                                    </td>
                                                    <td>{moment(item.created_time).format('DD/MM/YYYY')}</td>
                                                    <td className="text-right">
                                                        <Tooltip title="Mã Nhúng (Script)">
                                                            <Button 
                                                                size="small" 
                                                                type="dashed"
                                                                icon={<CodeOutlined />}
                                                                onClick={() => this.showScript(item.token)}
                                                                style={{ marginRight: 4 }}
                                                            />
                                                        </Tooltip>
                                                        <Tooltip title="Chỉnh sửa">
                                                            <Button 
                                                                size="small" 
                                                                icon={<EditOutlined />}
                                                                onClick={() => this.openModal(item)}
                                                                style={{ marginRight: 4 }}
                                                            />
                                                        </Tooltip>
                                                        <Tooltip title="Xóa">
                                                            <Button 
                                                                size="small" 
                                                                type="danger" 
                                                                icon={<DeleteOutlined />}
                                                                onClick={() => this.deleteChannel(item._id)}
                                                            />
                                                        </Tooltip>
                                                    </td>
                                                </tr>
                                            );
                                        })}
                                    </tbody>
                                </table>
                            ) : (
                                <Empty 
                                    description="Chưa có kênh Web Chat nào được tạo"
                                    style={{ padding: 40 }}
                                >
                                    <Button 
                                        type="primary" 
                                        icon={<PlusOutlined />}
                                        style={{ background: '#0068FF', borderColor: '#0068FF' }}
                                        onClick={() => this.openModal()}
                                    >
                                        Thêm Kênh Web Chat
                                    </Button>
                                </Empty>
                            )}
                        </Spin>
                    </div>
                </div>
            </div>
        );
    }
}
